import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            At <span className="red">RedDawg Tech</span>, we specialize in
            freelance consulting that helps small businesses get more out of
            their technology.  
            <br />
            <br />
            From custom websites and cloud solutions to on-prem infrastructure
            and data protection, we provide practical expertise without the
            overhead of a large agency.  
            <br />
            <br />
            Our focus is on delivering reliable applications, efficient hosting,
            and secure system management — all built around your business goals.
            With a flexible, client-first approach, we make sure technology
            empowers your growth instead of getting in the way.
          </p>
          <br />
          <br />
          <p className="blockquote-footer">
            "Technology should empower, not overwhelm. We build solutions that
            let your business thrive."{" "}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
